export type Enum<E> = Record<string, E | string> & Record<number, string>;

export function enumToExtendedArray<E>(enumType: Enum<E>) {
  return (Object.values(enumType).filter(x => typeof (x) !== 'string') as E[]).map(x => ({ value: x, label: enumType[x as unknown as number] }));
}
